import React from 'react';

import { CASINO_MIN_SEARCH_LENGTH } from '@/feature/lobby-casino/hooks/use-casino-games';

import { CasinoSearchResults } from '../components/CasinoSearchResults';
import { SearchScreenShell } from './SearchScreenShell';

export const CasinoSearchScreen = () => {
    return (
        <SearchScreenShell minQueryLength={CASINO_MIN_SEARCH_LENGTH}>
            <CasinoSearchResults />
        </SearchScreenShell>
    );
};
